import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const Icon3dBoxTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-Icon3dBoxTop"><Path d="M11.9998 1.75L20.8766 6.875V17.125L11.9998 22.25L3.12305 17.125V6.875L11.9998 1.75Z" stroke="currentColor"/><Path d="M20.8766 6.875L11.9998 12M11.9998 22.25V12M3.12305 6.875L11.9998 12" stroke="currentColor"/></CentralIconBase>;
});

export default Icon3dBoxTop;
